export { default } from './light-card.component';
